var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCrossMedium = function SvgCrossMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.313,
    height: 9.192
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 681",
    transform: "translate(-5 -5.121)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1883",
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-45 9.596 -3.268)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1884",
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(45 .56 18.838)"
  }))));
};

export default SvgCrossMedium;